import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import firebaseApp from "../fireconnect";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Button, Modal } from "react-bootstrap";

const BlogTable = () => {
  const [blogData, setBlogData] = useState([]);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedBlogId, setSelectedBlogId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleView = (blogId) => {
    const blog = blogData.find((b) => b.id === blogId);
    if (blog) {
      setSelectedBlog(blog);
      setOpenModal(true);
    }
  };

  useEffect(() => {
    fetchBlogData();

    if (location.state && location.state.message) {
      toast.success(location.state.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [location]);

  const fetchBlogData = () => {
    let db = firebaseApp.firestore();
    db.collection("Blog")
      .get()
      .then((querySnapshot) => {
        let blogs = [];
        querySnapshot.forEach((doc) => {
          blogs.push({ ...doc.data(), id: doc.id });
        });
        setBlogData(blogs);
      })
      .catch((error) => {
        console.error("Error fetching blog data:", error);
      });
  };

  const handleEdit = (blogId) => {
    const blogToEdit = blogData.find((blog) => blog.id === blogId);
    if (blogToEdit) {
      navigate("/Admin/AddBlog", {
        state: {
          blogData: blogToEdit,
          blogId: blogId,
        },
      });
    }
  };

  const Delete = (id) => {
    setSelectedBlogId(id);
    setConfirmDeleteOpen(true);
  };

  const confirmDelete = () => {
    if (!selectedBlogId) return;

    let db = firebaseApp.firestore();
    db.collection("Blog")
      .doc(selectedBlogId)
      .delete()
      .then(() => {
        const updatedData = blogData.filter(
          (blog) => blog.id !== selectedBlogId
        );
        setBlogData(updatedData);
        toast.success("Blog deleted successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      })
      .finally(() => {
        setConfirmDeleteOpen(false);
        setSelectedBlogId(null);
      });
  };

  const columns = [
    {
      name: "title",
      label: "Title",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const charLimit = 50;
          const truncatedValue =
            value.length > charLimit
              ? value.substring(0, charLimit) + "..."
              : value;
          return <div>{truncatedValue}</div>;
        },
        setCellHeaderProps: () => ({
          style: { width: "25%" },
        }),
      },
    },
    {
      name: "content",
      label: "Content",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => (
          <div
            className="ql-editor"
            dangerouslySetInnerHTML={{ __html: value }}
            style={{
              height: "auto",
              minHeight: "50px",
              maxHeight: "100px",
              overflow: "auto",
            }}
          />
        ),
        setCellHeaderProps: () => ({
          style: { width: "40%" },
        }),
      },
    },
    {
      name: "image",
      label: "Image",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div>
              {value && value.length > 0 ? (
                <div style={{ height: "100%", width: "80px" }}>
                  <img
                    alt="Blog"
                    src={value[0]}
                    style={{ height: "100%", width: "100px" }}
                    loading="lazy"
                  />
                </div>
              ) : (
                <p>No image available</p>
              )}
            </div>
          );
        },
        setCellHeaderProps: () => ({
          style: { width: "20%" },
        }),
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => (
          <div>
            <button
              className="btn btn-info m-1"
              onClick={() => handleView(value)}
            >
              <i className="bi bi-eye"></i>
            </button>
            <button
              className="btn btn-primary m-1"
              onClick={() => handleEdit(value)}
            >
              <i className="bi bi-pencil"></i>
            </button>
            <button
              className="btn btn-danger m-1"
              onClick={() => Delete(value)}
            >
              <i className="bi bi-trash3"></i>
            </button>
          </div>
        ),
        setCellHeaderProps: () => ({
          style: { width: "15%" },
        }),
      },
    },
  ];

  return (
    <>
      <div className="mt-1 text-start">
        <h4 className="mb-2">Blogs</h4>
        <ToastContainer />
        <MUIDataTable
          className="AdminTable rounded-2"
          data={blogData}
          columns={columns}
          options={{
            tableBodyHeight: "57vh",
            responsive: "standard",
            selectableRows: "none",
          }}
        />

        <Modal
          show={openModal}
          onHide={() => setOpenModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Blog Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <strong>Title:</strong> {selectedBlog?.title}
            </h6>
            <h6>
              <strong>Content:</strong>
            </h6>
            <div
              className="ql-editor"
              dangerouslySetInnerHTML={{ __html: selectedBlog?.content }}
            />
            {selectedBlog?.image?.length > 0 && (
              <>
                <h6 className="mt-3">
                  <strong>Images:</strong>
                </h6>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  {selectedBlog.image.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}
                      alt={`blog-img-${idx}`}
                      style={{ width: "100px", borderRadius: "5px" }}
                    />
                  ))}
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setOpenModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Dialog
          open={confirmDeleteOpen}
          onClose={() => setConfirmDeleteOpen(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <p>Are you sure you want to delete this blog?</p>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setConfirmDeleteOpen(false)}
              variant="secondary"
            >
              Cancel
            </Button>
            <Button onClick={confirmDelete} variant="danger">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default BlogTable;
